const mustBeCool = {
  $validator: (value) => {
    const regex = /[^a-zA-Z0-9-_]/g; // Matches any character that is NOT a letter, dash, or underscore
    return !regex.test(value);
  },
  // $message: 'test cool'
};

export default mustBeCool;
